import { render, staticRenderFns } from "./DeleteProviderReferences.vue?vue&type=template&id=ad22d7f6&"
import script from "./DeleteProviderReferences.vue?vue&type=script&lang=js&"
export * from "./DeleteProviderReferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports